import React, { useState } from 'react';
import DefaultPanel from '../DefaultPanel/DefaultPanel';
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-redeclare
import {Alert, Icons, Sentiments, Sizes} from '@sede-enterprise/shell-ds-react-framework'
import {
  DefaultContainer,
  MainContainer,
  DefaultTitleContainer,
} from './DefaultLayout.styled';

export interface IDefaultLayout {
  title?: string;
  message?: string;
  panel?: React.ReactNode;
  bidPanel?: React.ReactNode;
  children?:React.ReactNode
}

const DefaultLayout: React.FC<IDefaultLayout> = (props) => {
  const [showMessage, setShowMessage] = useState(true);
  return (
    <DefaultContainer data-testid="DefaultLayout">
      <DefaultPanel panel={props.panel} />
      <MainContainer>
        {props.message && showMessage &&
          <Alert 
          id="alertMessage" 
          dismissible={props.message!=null && showMessage}
          sentiment={Sentiments.Warning}
          size={Sizes.Small}
          icon={<Icons.InfoCircle style={{marginLeft:"3px"}} />}
          onDismissClick={()=>{
            setShowMessage(false);
          }}> <span style={{fontSize:"12px", color:"red"}} >{props.message}</span>
        </Alert>
        }
        
        <DefaultTitleContainer>{props.title}</DefaultTitleContainer>
        {props.children}
      </MainContainer>
      {props.bidPanel}
    </DefaultContainer>
  );
};

export default DefaultLayout;
